import React, {useState, useEffect} from 'react'

import { ValidationForm, TextInput } from 'react-bootstrap4-form-validation';
import { Button } from 'reactstrap';
import { Modal, ModalDialog } from 'react-bootstrap';
import ShowMessages from '../../components/Exceptions'
import Loading from '../../components/Loading';
import Draggable from 'react-draggable';

import api from '../../services/api';
import setStatistic from '../../services/apiStatistic'
import  loadingButton  from './../layouts/Buttons'

class DraggableModalDialog extends React.Component {
	render() {
		return <Draggable handle=".modal-header"><ModalDialog {...this.props} /></Draggable>
	}
}

export default function ModalVideos({showModal, handleCloseModal,editState, data, handleReload}) {
    const [loading, setLoading]  = useState(false)

    const [url,setURL]           = useState('')
    const [localurl,setLocalURL] = useState(false)

    const setData = (obj,clear) => {
        setURL(clear ? '' : obj.url) 
        setLocalURL(clear ? false : obj.localurl)
    }

    const handleSubmit = async(event) => {
        event.preventDefault()
        loadingButton(true,document.querySelector('#submit-videos'),document.querySelector('#submit-videos').children[0].classList,document.querySelector('#submit-videos').lastChild.nodeValue)
        try {
             let _data = {url,
                          localurl}

            if (editState)
                await api.put('/videos/' + data.idvideo, _data)
                         .then(response => {
                            ShowMessages(response)
                            if (response.ok) {
                                if (response.data.status === 200) {
                                    handleCloseModal()  
                                    handleReload(true)    
                                } else
                                    loadingButton(false,document.querySelector('#submit-videos')) 
                            } else
                                loadingButton(false,document.querySelector('#submit-videos')) 
                        })
                        .catch( error => {
                            loadingButton(false,document.querySelector('#submit-videos'))
                            ShowMessages(error) 
                        })
            else
                await api.post('/videos', _data)
                         .then(response => {
                             ShowMessages(response)
                             if (response.ok) {                                    
                                if (response.data.status === 200) {
                                    handleCloseModal()  
                                    handleReload(true)    
                                } else
                                    loadingButton(false,document.querySelector('#submit-videos'))         
                             } else
                                loadingButton(false,document.querySelector('#submit-videos')) 
                         })
                        .catch( error => {
                            loadingButton(false,document.querySelector('#submit-videos'))
                            ShowMessages(error) 
                        })
        } catch (response) {
            loadingButton(false,document.querySelector('#submit-videos'))
            ShowMessages(response)
        }
    }
    
    useEffect(() => {
        if (editState) 
            setData(data,false)
        else 
            setData({},true)
    },[data,editState,showModal])
   
    useEffect(() => {
        setStatistic('modals\\modal-videos')
    } ,[])

    return (
        <Modal size='lg' show={showModal} onHide={handleCloseModal} animation={true} backdrop="static"  dialogAs={DraggableModalDialog}>
            <ValidationForm onSubmit={handleSubmit} setFocusOnError={true} className="modal-content"> 
                <Modal.Header closeButton>
                    <Modal.Title style={{marginBottom:"0px"}}>
                        <i className="fa fa-video"></i> Propriedades de Vídeos
                    </Modal.Title>
                </Modal.Header>
            
                <Modal.Body>
                    <Loading loading={loading}/>
                    <div className={`${loading ? "hidden" : ""}`}>               
                        <div>
                            <label>URL do vídeo | ID Vídeo Youtube</label>
                            <div className="input-group">
                                <TextInput  
                                    name="url"
                                    id="url"
                                    type="text"
                                    required
                                    autoFocus={true}
                                    maxLength={100}
                                    errorMessage={{ required: "Por favor, informe uma URL!" }}
                                    value={url}
                                    className="form-control "
                                    onChange={e => setURL(e.target.value)}
                                    autoComplete="off"/>
                            </div>
                        </div>                                    
                    </div>
                    <div style={{display:"flex",alignItems:"center"}}>
                        <input type="checkbox" checked={localurl} onChange={e => setLocalURL(!localurl)} className="form-check-input" style={{marginLeft:"0px"}}/>
                        <span style={{marginLeft:"20px",marginTop:"4px"}}>URL Local?</span>
                    </div>
                </Modal.Body>
                <Modal.Footer>  
                    <Button type="submit" id="submit-videos" className={`btn-theme ${loading ? "hidden" : ""}`}>
                        <em className="fa fa-save"></em> Salvar
                    </Button>          
                    <Button className="btn-ligth-gray" onClick={handleCloseModal}>
                        <em className="fa fa-door-closed"></em> Fechar
                    </Button>
                </Modal.Footer>
            </ValidationForm> 
        </Modal>
    )
}